import { Input } from '@trarc/pc-shared';
import styled from 'styled-components';

export const PickersContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  ${Input} {
    width: unset;
  }
`;
